export enum SessionEventsRoutes {
  CreateOne = 'create-one',
  ExportShots = 'export-shots',
  GetLogin = 'get-login',
  GetManyFromSession = 'get-many-from-session',
  SummarizeMachines = 'summarize-machines',
  SummarizeUser = 'summarize-user',
  UpdateOne = 'update-one',
}
